module.exports = __webpack_public_path__ + "static/media/speaker_BU_SamsonTai.f920923a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/speaker/speaker_BU_SamsonTai.jpg
// module id = 243
// module chunks = 0